import { useFormContext } from "react-hook-form"
import { PhoneCodes } from "content/PhoneCodes"
import { CompleteFormSelect } from "components/views/atoms/forms/FormSelect"
import { PhoneCodeSelectOptions } from "content/PhoneCodeSelectOptions"
import { CompletePrefixInput } from "components/views/atoms/forms/FormPrefixInput"
import React from "react"
import L10n from "lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CountryCodeAndPhoneNumberInputs = ({ onChange }) => {
  const { register, errors, watch } = useFormContext()
  const countryCode = watch("countryCode")
  const phoneCode = PhoneCodes[countryCode]

  return (
    <>
      <CompleteFormSelect
        name="countryCode"
        ref={register}
        onChange={onChange}
        label={l`country code`}
        options={PhoneCodeSelectOptions}
      />
      <CompletePrefixInput
        name="phoneNumber"
        onChange={onChange}
        ref={register({
          required: l`Please enter a valid phone number`
        })}
        errors={errors}
        label={l`phone number`}
        prefixText={phoneCode ? `+${phoneCode}` : ""}
        showValidation
      />
    </>
  )
}

export { CountryCodeAndPhoneNumberInputs }
